// zh_TW language file
// Generated from Feishu Bitable
// Total entries: 565

export default{
    "game_diamond": {
        "title": "遊戲鑽說明",
        "title0_title": "如何獲得遊戲鑽",
        "title0": {
            "txt1": "1. 可透過指定任務或活動獲得。",
            "txt2": "2. 無法透過儲值購買。"
        },
        "title1_title": "遊戲鑽的用途",
        "title1": {
            "txt1": "1. 只能用於遊戲。",
            "txt2": "2. 在遊戲內，遊戲鑽等同於普通鑽石，可直接使用。使用遊戲鑽贏得的鑽石為普通鑽。",
            "txt3": "3. 優先消耗遊戲鑽。",
            "txt4": "4. 可與鑽石一併使用，如：200遊戲鑽+800鑽可用於1000消耗。"
        },
        "title2_title": "遊戲鑽的有效期",
        "title2": {
            "txt1": "1. 有效期有限，過期將被系統回收。"
        }
    },
    "guanxi_gift_rule_title": "禮物說明",
    "guanxi_gift_rule_1": "贈送關系禮物後，對方可選擇是否與你成為關系。雙方之間只能存在一種關系。",
    "guanxi_gift_rule_2": "每人最多有3個關系，關系類型可以相同。",
    "guanxi_gift_rule_3": "成為關系24小時後可以解除關系。解除關系24小時候可再次成為關系",
    "not_exist": "未找到",
    "mbti_intro_title": "MBTI 說明",
    "mbti_intro_pers": "性格特點",
    "mbti_intro_love": "戀愛特點",
    "mbti_intro_istj_pers": "檢查員型人格",
    "mbti_intro_istj_feature": "嚴肅、安靜、註重細節和準確性，喜歡有秩序和有組織的生活。他們責任心強，可靠，善於遵循規則和傳統。",
    "mbti_intro_istj_love": "在戀愛中，ISTJ 會是一個忠誠、穩定的伴侶。他們會認真對待感情，註重承諾和責任，願意為對方付出實際的行動。但可能不太善於表達情感，需要時間來建立深度的情感連接。",
    "mbti_intro_isfj_pers": "照顧者型人格",
    "mbti_intro_isfj_feature": "溫柔、體貼、善良，有很強的同情心和耐心。他們註重細節，善於照顧他人的需求，是很好的傾聽者和支持者。",
    "mbti_intro_isfj_love": "ISFJ在戀愛中會全身心地關註對方，關心對方的生活細節，善於營造溫馨、舒適的戀愛氛圍。他們比較傳統和保守，可能需要較長時間來確定戀愛關系，但一旦確定，就會非常忠誠。",
    "mbti_intro_infj_pers": "建築師型人格",
    "mbti_intro_infj_feature": "富有洞察力和創造力，對人性和未來有深刻的理解。他們內心世界豐富，情感深沈，善於思考和分析。",
    "mbti_intro_infj_love": "INFJ在尋找伴侶時，更註重精神上的共鳴和契合。他們渴望與伴侶進行深入的思想交流，對愛情有著很高的理想和期待。一旦陷入愛河，會非常專註和深情。",
    "mbti_intro_intj_pers": "指揮官型人格",
    "mbti_intro_intj_feature": "理性、冷靜、自信，具有很強的邏輯分析能力和決策能力。他們追求知識和智慧，對自己的目標有著堅定的追求。",
    "mbti_intro_intj_love": "INTJ 在戀愛中會以理性的方式對待感情，註重雙方的價值觀和目標是否一致。他們可能不會輕易表達情感，但會通過實際行動來表達對伴侶的關心和支持。",
    "mbti_intro_istp_pers": "工匠型人格",
    "mbti_intro_istp_feature": "冷靜、實際、善於觀察和分析。他們喜歡動手操作，解決實際問題，對機械和技術有著濃厚的興趣。",
    "mbti_intro_istp_love": "ISTP 在戀愛中比較隨性和自由，不喜歡受到過多的約束。他們註重當下的感受和體驗，會與伴侶一起享受生活中的樂趣。",
    "mbti_intro_isfp_pers": "藝術家型人格",
    "mbti_intro_isfp_feature": "敏感、溫柔、富有藝術氣質。他們註重內心的感受和情感體驗，善於用藝術的方式表達自己。",
    "mbti_intro_isfp_love": "ISFP 在戀愛中會非常浪漫和體貼，善於營造浪漫的氛圍，給對方帶來驚喜和感動。他們比較情緒化，需要伴侶的理解和包容。",
    "mbti_intro_infp_pers": "調停者型人格",
    "mbti_intro_infp_feature": "理想主義、善良、富有同情心，內心世界豐富而敏感。他們追求和諧與美好，對人性有著深刻的理解和信任。",
    "mbti_intro_infp_love": "INFP 在戀愛中會全身心地投入，渴望與伴侶建立深厚的情感連接。他們註重情感的交流和共鳴，對愛情有著美好的憧憬和期待。",
    "mbti_intro_intp_pers": "邏輯學家型人格",
    "mbti_intro_intp_feature": "理性、冷靜、善於思考和分析。他們對知識有著強烈的渴望，喜歡探索未知的領域，追求真理和智慧。",
    "mbti_intro_intp_love": "INTP 在戀愛中會以理性的方式對待感情，註重雙方的思想交流和精神契合。他們可能不會輕易表達情感，但會通過理性的分析和討論來加深對彼此的了解。",
    "mbti_intro_estp_pers": "企業家型人格",
    "mbti_intro_estp_feature": "熱情、外向、樂觀，喜歡與人交往和冒險。他們具有很強的現實感和行動力，善於把握機會。",
    "mbti_intro_estp_love": "ESTP 在戀愛中充滿活力和熱情，喜歡與伴侶一起嘗試新的事物，享受生活的樂趣。他們比較直接和坦率，會大膽地表達自己的情感和想法。",
    "mbti_intro_esfp_pers": "表演者型人格",
    "mbti_intro_esfp_feature": "外向、樂觀、熱情，喜歡與人交往和娛樂。他們具有很強的表現力和感染力，善於製造歡樂和氛圍。",
    "mbti_intro_esfp_love": "ESFP 在戀愛中會是一個充滿活力和樂趣的伴侶，喜歡與對方一起參加各種社交活動和娛樂項目。他們註重當下的感受和體驗，會給對方帶來很多快樂和驚喜。",
    "mbti_intro_enfp_pers": "小太陽型人格",
    "mbti_intro_enfp_feature": "熱情、樂觀、富有創造力，充滿活力和好奇心。他們善於與人交往，能夠很好地理解和感受他人的情感。",
    "mbti_intro_enfp_love": "ENFP 在戀愛中會像小太陽一樣，給對方帶來溫暖和快樂。他們充滿浪漫和幻想，喜歡與伴侶一起創造美好的回憶。他們對愛情充滿熱情，會積極地表達自己的情感。",
    "mbti_intro_entp_pers": "辯論家型人格",
    "mbti_intro_entp_feature": "聰明、機智、善於思考和辯論。他們具有很強的好奇心和求知欲，喜歡探索新的事物和思想。",
    "mbti_intro_entp_love": "ENTP 在戀愛中會與伴侶進行深入的思想交流和辯論，他們喜歡挑戰和被挑戰，希望通過這種方式來加深對彼此的了解。他們可能會比較調皮和幽默，給戀愛生活帶來很多樂趣。",
    "mbti_intro_estj_pers": "總經理型人格",
    "mbti_intro_estj_feature": "實際、果斷、自信，具有很強的組織能力和領導能力。他們註重效率和結果，喜歡按照計劃行事。",
    "mbti_intro_estj_love": "- ESTJ 在戀愛中會比較主動和強勢，他們會積極地追求自己喜歡的人，並努力為雙方的未來規劃和努力。他們註重實際行動，會通過物質和實際的幫助來表達對伴侶的關心和愛。",
    "mbti_intro_esfj_pers": "執政官型人格",
    "mbti_intro_esfj_feature": "熱情、友好、善於照顧他人，具有很強的社交能力和組織能力。他們註重傳統和家庭，喜歡與人建立深厚的情感聯系。",
    "mbti_intro_esfj_love": "ESFJ 在戀愛中會非常體貼和關心對方，善於營造溫馨、和諧的戀愛氛圍。他們比較傳統和保守，會遵循傳統的戀愛方式和禮儀，註重家庭和社會的認可。",
    "mbti_intro_enfj_pers": "主人公型人格",
    "mbti_intro_enfj_feature": "熱情、自信、富有領導力，善於與人交往和溝通。他們具有很強的洞察力和感染力，能夠很好地理解和引導他人。",
    "mbti_intro_enfj_love": "ENFJ 在戀愛中會是一個熱情、浪漫的伴侶，他們善於表達自己的情感，會給對方帶來很多溫暖和感動。他們註重雙方的情感交流和共鳴，希望與伴侶建立深厚的情感連接。",
    "mbti_intro_entj_pers": "指揮官型人格",
    "mbti_intro_entj_feature": "理性、果斷、自信，具有很強的領導能力和決策能力。他們追求卓越和成功，對自己和他人都有著很高的要求。",
    "mbti_intro_entj_love": "ENTJ 在戀愛中會以理性和目標為導向，他們會選擇與自己誌同道合、能夠共同成長和進步的伴侶。他們註重雙方的能力和素質，會通過共同的事業和目標來加深彼此的感情。",
    "expressProposalWall": "表白墻",
    "expressHowTo": "如何登上表白墻",
    "expressSend": "將表白禮物送給妳的愛人，妳的愛意文字將顯示在表白墻上。",
    "expressSend1": "1.點擊“立即表白”，進入活動頁面，選擇妳要表白的對象。",
    "expressSend2": "2.選擇禮物並在卡片上輸入妳想對他說/她的話。",
    "expressSend3": "3.點擊發送禮物，妳的表白卡片將展示在表白墻上。",
    "expressDifferent": "表白禮物種類",
    "expressWeHave": "我們提供以下四種表白禮物：",
    "expressWeHave1": "1.基礎表白禮物卡：簡單的純色背景。",
    "expressWeHave2": "2.裝飾表白禮物卡：多彩裝飾背景。",
    "expressWeHave3": "3.豪華表白禮物卡：帶有奢華效果的裝飾背景。",
    "expressWeHave4": "4.真愛表白禮物卡：帶有奢華效果的裝飾背景，並伴有全服廣播。",
    "expressProposal": "表白卡片展示範圍",
    "expressProposal1": "1.房間內的表白墻。（點擊表白禮物上方的條）",
    "expressProposal2": "2.動態頁面旁的表白墻。",
    "diamondDrop1": "1.當房間內用戶每單次送禮總額超過50000鉆石（幸運禮物按照實際鉆價*0.1計算），房間內則會掉落1個鉆石寶箱，所有用戶都可開啟寶箱搶得鉆石。",
    "diamondDrop2": "2.每個寶箱在開啟前有1分鐘的等待時間。",
    "diamondDrop3": "3.每個寶箱鉆石數量有限，寶箱開啟倒計時結束後，則不可再領取該寶箱內鉆石。",
    "diamondDrop4": "4.寶箱結束後可點擊查看在該寶箱內搶得的鉆石。",
    "baoxaingxianding": "寶箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "在恢復期間，您可以使用賬號之前的登錄方式重新登錄並選擇恢復賬號。壹旦賬號恢復，您將能夠繼續訪問您的賬號，包括所有保存的消息、等級和貨幣資產等。",
        "accountRecoveryTitle": "賬號恢復：",
        "confirmCancellation": "您仍然要註銷帳號嗎？",
        "convalescenceContent": "註銷申請提交後的30天內，盡管賬號將被暫時停用，但我們會保留您賬號內的所有信息、等級、貨幣資產等數據，以便在您決定恢復賬號時，壹切如故。",
        "convalescenceTitle": "恢復期：",
        "finalContent": "如果在恢復期結束時（即從提交註銷申請之日起的第31天），您沒有選擇恢復賬號，您的賬號及其所有數據將被永久刪除。請註意，壹旦賬號被永久刪除，將無法恢復，所有相關數據也將不可逆轉地丟失。",
        "finalTitle": "最終註銷：",
        "reserveContent": "在恢復期間，我們將保護您的賬號數據安全，確保數據不會在恢復期間遺失或受損。",
        "reserveTitle": "數據保留：",
        "statementContent": "註銷申請：當您提交賬號註銷申請後，您的賬號將進入30天的“恢復期”。在此期間您可以隨時選擇恢復賬號。如果您加入公會，將不可進行帳號註銷",
        "statementTitle": "賬號註銷聲明：",
        "userContent": "感謝您使用我們的服務。我們理解，有時您可能需要做出註銷賬號的決定。為確保您的選擇是經過深思熟慮的，並為您提供可能的反悔機會，我們特此說明賬號註銷流程及相關條款。",
        "userTitle": "尊敬的用戶："
    },
    "Countdown": "倒數計時",
    "Endactivity": "活动已经结束",
    "eventDetails": "活動詳情",
    "eventGifts": "活動禮物",
    "eventList": "活動榜單",
    "eventReward": "活動獎勵",
    "eventRewards": {
        "player": "每日活躍玩家人數",
        "proportion": "房間獲勝時的返獎百分比",
        "title": "活動返獎",
        "txt1": "1. 每天凌晨0點（UTC+8）計算昨日的數據。",
        "txt2": "2. 根據房間內參與的人數和房間內實際消耗的鑽石（用戶下注鑽石 - 用戶獲得鑽石）進行返獎。",
        "txt3": "3. 每週一凌晨0點（UTC+8）計算上週數據，獎勵將在3日內下發。",
        "txt4": "4. 返獎比例：",
        "txt5": "5. 活躍玩家定義：當日累計下註超過1000鉆。"
    },
    "EventRules": "活動規則",
    "Eventtime": "活動時間：",
    "guild": {
        "guild_certification01": "公會認證",
        "guild_certification02": "歡迎娛樂公會入駐",
        "guild_certification03": "招募要求",
        "guild_certification04": [
            "一周內完成10名簽約主播並入駐",
            "能提供公會長身份證等實名證件",
            "提供公會簡介、團隊介紹、主播資料、主播收益規則等"
        ],
        "guild_certification05": "滿足以上條件，發送資料到官方認證郵箱中：billionairepte@gmail.com審核通過後會有專員與您聯系",
        "guild_certification06": "號碼已復製到剪切板",
        "guild_certification07": "入駐諮詢方式：",
        "guild_certification08": "複製",
        "guild_certification09": "入會須知",
        "guild_certification10": [
            {
                "title": "1. 入會規則",
                "value": [
                    "申請人與公會長協商一致，在平台內發起入會申請，會長審核通過後，則成為公會簽約主播，產生公會貢獻"
                ]
            },
            {
                "title": "2. 退會規則",
                "value": [
                    "入會成功後若要退會，主播需要與會長協商一致，在公會資料頁點擊【退會申請】，會長點擊【同意退會】後，成員將立即退出公會。",
                    "退會成功後可再申請加入其他公會。"
                ]
            }
        ],
        "guild_certification11": "公會說明",
        "guild_certification12": [
            {
                "title": "公會收入",
                "value": [
                    "1.家族房裡的用戶和主播領取禮品，生成公會貢獻",
                    "2.家族房裡進行boss攻擊",
                    "3.公會簽約的主播創建cp房間，領取禮物產生公會貢獻（加入家族後，未簽約的主播無法創建cp房間產生家族貢獻）"
                ]
            }
        ],
        "InvitationCodeTitle": "邀請碼",
        "invite_rules_intriduction": "邀請規則介紹",
        "invite_rules_intriduction_content": [
            "1.主播可以通過註冊時填寫邀請碼直接申請加入你的公會，並且成為主播",
            "2.未填寫邀請碼注册的主播，可以再通過進入家族頁面申請加入你的家族，之後再申請成為主播"
        ]
    },
    "legend": {
        "title": "Legendary February"
    },
    "officialMember": "Official Member",
    "prettyNumber": {
        "text": "Ⅰ. 領取靚號",
        "text1": "1. 成為貴族3及以上後可以領取1個對應等級的靚號。",
        "text2": "2. 高等級的VIP可以領取一個低等級的靚號。如貴族6可以領取一個LV3的靚號。",
        "text3": "1. 貴族到期之後，靚號也同時不可使用，需要激活貴族才可繼續使用靚號。",
        "text5": "1. 一旦領取了一個靚號，不可以更換成同等級及以下的靚號",
        "text6": "2. 靚號使用期間獲得更高等級的貴族，可以立刻更換一個高等級的靚號，同時原靚號會進入商城。",
        "text7": "3. 例如，一個貴族4的用戶首先領取了一個貴族4的靚號，之後用戶又升級為了貴族6，則用戶不能更換為貴族4及以下的靚號，但是可以立刻領取一個貴族6的靚號。",
        "title": "說明",
        "title1": "Ⅱ. 靚號到期",
        "title2": "Ⅲ. 靚號更換"
    },
    "reception": {
        "reception01": "收禮榜說明",
        "reception02": [
            {
                "title": "1.什麼是房間收禮榜單",
                "value": [
                    "房間收禮榜是房間收禮數的實時榜單",
                    "房間收禮數=鑽石收禮數"
                ]
            },
            {
                "title": "2.房間收禮榜如何排序",
                "value": [
                    "根據所有房間的收入，通過綜合計算進行排序",
                    "小時榜：UMT+8時區，每一小時刷新重置",
                    "日榜：UMT+8時區，第二天0點刷新重置"
                ]
            },
            {
                "title": "3.小時榜Top1，全服推送",
                "value": [
                    "房間收禮小時榜Top1，在全服房間中進行"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "返回",
        "event_rule": "<p>1. 時長榜：統計活動期間房間內用戶在10個麥位上累計在麥時長，最終榜單Top3房間貢獻麥時最高3人獲得獎勵；</p><p>2. 豪氣榜：統計活動時間房間內累計收到的鑽石數，最終榜單Top3房間中每個房間消耗鑽石最高的3人獲得獎；</p><p>3. 本活動爲週循環活動，每週榜單會重新進行統計。</p>",
        "last_week": "上週",
        "last_week_rank": "上週榜單詳細",
        "reward": "獎勵",
        "rich_rank": "豪气榜",
        "rule": "規則",
        "rule_reward": "規則&獎勵",
        "time_rank": "时长榜",
        "title": "Family party",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "頭像框14天",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "入場特效14天",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "頭像框14天",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "頭像框7天",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "Top Up Rewards",
    "treasure_chest": {
        "title": "寶箱禮物說明",
        "value1": "1. 寶箱禮物分為木寶箱、銀寶箱、金寶箱",
        "value2": "2. 打開寶箱後，將隨機從寶箱中獲得一個禮物並送出。",
        "value3": "3. 送禮方根據消耗的鉆石數獲得經驗值，收禮方根據寶箱開出的禮物，獲得對應價值的Pocket幣和魅力值。",
        "value4": "4. 木寶箱，單價1500鉆石，可以開出的禮物：",
        "value5": "5. 銀寶箱，單價7500鉆石，可開出禮物：",
        "value6": "6. 金寶箱， 單價 25000鉆石，可開出禮物：",
        "value7": "7. 寶箱禮物僅供娛樂交流，任何影響公平性、利用產品Bug等不正當手段參與的行動將被禁止。平臺一經發現將做封號處理，並保留一切追究法律責任的權利。"
    },
    "treasure_name": {
        "name1": "木寶箱",
        "name2": "銀寶箱",
        "name3": "金寶箱",
        "name4": "概率"
    },
    "Value": "價值：",
    "Webname": {
        "addUid": "新增UID",
        "balance": "餘額：",
        "Confirm": "確認",
        "err_uid": "UID錯誤，請重新輸入",
        "lang": "選擇語言",
        "Query": "査詢",
        "recharge": "充值中心",
        "Recharge": "充值",
        "self": "渠道",
        "uid": "Change UID",
        "uuserName": "用戶昵稱：",
        "Withdrawal": "提現"
    },
    "Weekly_Cp": {
        "7days": "7天",
        "back": "返回",
        "countdown": "本週倒計時",
        "day": "天",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>1. 榜單統計用戶贈送給另一位用戶活動禮物所産生的cp值，1鑽石=1cp值，當期榜單結束後Top3的CP組合獲得活動獎勵；</p><p>2. 本活動爲循環活動；</p><p>3. 活動獎勵會在活動結束後3個工作日內髮放。</p>",
        "gift": "活動禮物",
        "hour": "小時",
        "last_week": "上週",
        "last_week_rank": "上週榜單詳細",
        "minute": "分鐘",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "獎勵",
        "rule": "規則",
        "rule_reward": "規則&獎勵",
        "seconds": "秒",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "週星頭像框",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "最佳助力頭像框",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "週星套裝",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "前4-6名",
        "top710": "前7-10名"
    },
    "Withdrawal": "提現說明",
    "withdrawalInstructions": {
        "text1": "1. 提現功能當前僅部分國家。",
        "text2": "2. 提現到賬時間會因渠道而異。",
        "text3": "3. 提現實際到賬金額會受匯率變化，手續費等影響，比展示金額略低。",
        "text4": "4. 每天僅能提現1次。",
        "text5": "5. 如果你遇到任何問題，<span>請 聯系我們</span>。"
    },
    "withdrawalLogin": {
        "accountId": "Pix帳戶ID",
        "accountIdTips": "",
        "accountIdtsa": "Pix帳號ID不能為空",
        "accountType": "Pix帳戶類型",
        "code": "驗證碼:",
        "Confirm": "確認",
        "documentId": "受益人的個人身分證號碼",
        "documentIdTips": "",
        "documentIdtsa": "身分證(ID)型別不能為空",
        "documentType": "受益人的個人身分證類型",
        "getAccount": "獲取帳號",
        "getUserId": "請輸入用戶ID",
        "incorrectAccount": "帳號不正確",
        "login": "登錄",
        "loginSuccessful": "登錄成功",
        "name": "pix用戶名",
        "nameTips": "",
        "nametsa": "長度需在5到100之間",
        "officialGroup": "如果有任何疑問，請聯繫官方人員。",
        "pocket": "Pocket币余額",
        "Pocket": "Pocket币餘額不足。",
        "Send": "發送",
        "text": "驗證碼將發送到應用內",
        "title": "收益提現",
        "title2": "提現詳情",
        "user_id": "賬號ID：",
        "Whatsapp": "Whatsapp帳號不正確",
        "WhatsappTips": "",
        "applicationTime": "申請日期",
        "amount": "提現金額",
        "success": "成功",
        "applicationSuccess": "已提交申請"
    },
    "top1AnchorRewards": "Top1主播獎勵",
    "top2_3AnchorRewards": "Top2-3主播獎勵",
    "top4_10AnchorRewards": "Top4-10主播獎勵",
    "top1Icon7day": "頭框Icon*7天",
    "top1_2Icon7day": "入場特效Icon*7天",
    "top3Icon7day": "頭框Icon*7天",
    "top1VIPRewards": "Top1儲值獎勵",
    "top2_3VIPRewards": "Top2-3儲值獎勵",
    "top4_10VIPRewards": "Top4-10儲值獎勵",
    "relastionship": {
        "des": [
            "",
            "1. 贈送關係禮物後，對方可選擇是否與你建立關係。雙方之間只能存在一種關係。",
            "2. 在建立關係後的7個自然日（UTC+3）內，關係親密值不會衰減。過了關係保護期後，一天內親密值未上升50度，則次日0點衰減10%（最少1）。當親密值為0時，次日0點解除關係。若連續10天親密值未上升50度，則次日0點自動解除關係。",
            "3. 成為關係24小時後可以解除關係。解除關係24小時後可再次成為關係。",
            "4. 每人預設有3個關係位置，你可花費鑽石購買關係位置，每個關係位價格為99999鑽石，最多可購買10個。你也可以透過提升VIP等級來增加關係位置。",
            "VIP等級",
            "共可擴展關係位"
        ]
    },
    "gift_album_des1": "贈送以上禮物可幫助他/她點亮 周圖鑑-《環遊世界》並獲得獎勵",
    "gift_album_des2": "贈送以上禮物可幫助他/她點亮 永久圖鑑-《心動焦點》並獲得獎勵",
    "gift_album_des3": "贈送以上禮物可幫助他/她點亮 永久圖鑑-《SVIP的守護》並獲得獎勵",
    "gift_album_des4": "贈送以上禮物可幫助他/她點亮 永久圖鑑-《夢中的婚禮》並獲得獎勵",
    "gift_album_des5": "前往【個人主頁】-【禮物牆】-【圖鑑】查看詳情",
    "gift_album_des8": "贈送以上禮物可幫助他/她點亮永久圖鑑-《生日派對》並獲得獎勵",
    "gift_album_des7": "贈送以上禮物可幫助他/她點亮 永久圖鑑-《房間之星》並獲得獎勵",
    "gift_harifata": "哈利法塔",
    "gift_sailing_hotel": "帆船酒店",
    "gift_mosque": "大清真寺",
    "gift_abatta": "阿巴特塔",
    "gift_sphinx": "狮身人面像",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "心動信號",
    "gift_conf_lv2": "墜入愛河",
    "gift_conf_lv3": "愛無止境",
    "gift_conf_lv4": "壹生壹世",
    "gift_habibi": "兄弟",
    "gift_bestie": "閨蜜",
    "gift_couple": "情侶",
    "gift_confidant": "知己",
    "weding_gift_kiss": "親吻",
    "weding_gift_ring": "戒指",
    "weding_gift_proposal": "求婚",
    "weding_gift_castle": "城堡",
    "weding_gift_wedding_dress": "婚紗",
    "weding_gift_wedding": "婚禮",
    "gift_album_des6": "規則",
    "guild_can_with": "可用",
    "guild_with_ing": "處理中",
    "guild_self_withdraw": "自助提現",
    "guild_transfer_to_leader": "轉給公會會長",
    "guild_salary_to_reseller": "轉給經銷商",
    "guild_convert_to_diamond": "兌換成鑽石",
    "guild_platform_settlement": "平台結算",
    "guild_withdrawal_records": "提現紀錄",
    "guild_current_withdrawable_pcoin": "可用幣",
    "guild_transfer_pcoin_amount": "轉帳金額",
    "guild_all": "全部",
    "guild_read_before_withdraw": "提現前請閱讀：",
    "guild_withdraw_note_1": "提交",
    "guild_withdraw_note_2": "可提現幣不足",
    "guild_min_withdraw_amount": "確認提交？",
    "guild_withdraw_note_4": "取消",
    "guild_appeal_to_platform": "確認",
    "guild_submit_application": "提現方式",
    "guild_withdraw_below_min": "會長提現",
    "guild_confirm_submit_application": "申請時間",
    "guild_freeze_notice": "處理時間",
    "guild_communicate_with_leader": "駁回原因",
    "guild_cancel": "退回金額",
    "guild_confirm": "待處理",
    "guild_withdrawal_method": "已完成",
    "guild_leader_withdraw": "已拒絕",
    "guild_status_timeout_rejected": "超時自動拒絕",
    "guild_status_unknown": "未知",
    "guild_status_platform_review": "平台審核中",
    "guild_status_guild_review": "經紀公司審核中",
    "guild_status_timeout_rejected_2": "超時退回",
    "guild_status_platform_rejected": "平台拒絕",
    "guild_status_guild_leader_approval": "預計<span>{n}</span>小時後交由經紀公司審批",
    "guild_apply_time": "僅顯示近 3 個月",
    "guild_process_time": "提現有疑問？",
    "guild_rejection_reason": "聯絡客服",
    "guild_amount_refunded": "已認證經銷商",
    "guild_status_pending": "僅限經銷商",
    "guild_status_completed": "可用",
    "guild_status_rejected": "轉帳金額",
    "guild_show_last_3_months": "預計到帳",
    "guild_withdrawal_question": "成功",
    "guild_contact_customer_service": "兌換成鑽石",
    "guild_certified_reseller": "可兌換幣",
    "guild_not_reseller_cannot_transfer": "兌換",
    "guild_current_withdrawable": "已兌換",
    "guild_transfer_amount": "已結算幣",
    "guild_estimated_arrival": "申請已提交",
    "guild_read_before_operation": "1. 請先與經銷商確認線下付款資訊",
    "guild_transfer_note_1": "2. 僅支援轉給經銷商",
    "guild_transfer_note_2": "確認轉帳",
    "guild_confirm_transfer": "確認提交？",
    "guild_confirm_submit_transfer": "將扣除 {n} 金幣",
    "guild_deduct_pcoin_receive_diamond": "請與經銷商協調付款細節",
    "guild_communicate_with_reseller": "交易成功",
    "guild_operation_success": "兌換成鑽石",
    "guild_exchange_diamond": "可兌換幣",
    "guild_current_exchangeable_pcoin": "兌換",
    "guild_exchange": "兌換成功",
    "guild_exchange_success": "待結算幣",
    "guild_settlement_pcoin_amount": "1. 請先與營運團隊確認提現方式",
    "guild_settlement_note_1": "2. 款項將於下週一處理",
    "guild_settlement_note_2": "3. 最低提現金額：{n} Coins",
    "guild_settlement_min_amount": "申請已提交",
    "guild_application_submitted": "將扣除 {n} Coins",
    "guild_deduct_pcoin": "請與營運團隊協調付款細節",
    "guild_user_not": "找不到使用者",
    "guild_please_enter_amount": "請輸入金額",
    "guild_insufficient_balance": "餘額不足",
    "guild_please_enter_reseller_uid": "請輸入 RESELLER UID",
    "guild_please_search_reseller_first": "請先搜尋 RESELLER",
    "guild_select_hand": "選擇操作",
    "guild_ci_hand": "1. 此操作將向公會長提交申請，",
    "guild_offline_transfer_funds": "並由會長線下向您付款",
    "guild_ci_hand_2": "2. 請提前與會長確認收款方式（銀行卡 / USDT 等）",
    "guild_ci_hand_3": "3. 最低提現金額為 {n} Coins",
    "guild_ci_hand_4": "4. 若會長確認已付款但您未收到，請保留聊天記錄並",
    "guild_ci_hand_5": "向平台申訴",
    "guild_ci_hand_6": "系統將凍結 {n} Coins 直到會長處理",
    "guild_ci_hand_7": "請與會長確認提現渠道，付款為線下處理",
    "guild_tips_1": "可提現 Coins 低於最低金額",
    "guild_contact_service": "請聯繫營運人員安排付款",
    "guild_reseller_tips": "你的幣已轉為對方的鑽石，請與對方溝通付款事宜。",
    "gift_collection_detail_permanent_birthday": "生日派對",
    "gift_collection_detail_permanent_roomstar": "房間之星",
    "gift_holy_sword": "神聖之劍",
    "gift_volcano": "火山",
    "gift_emperor_come_world": "歐皇降世",
    "gift_castle_of_love": "愛的城堡",
    "gift_Immortal_god_war": "不朽戰神",
    "gift_king_of_gods": "眾神之王",
    "birthday_gift_cybergift": "賽博禮物",
    "birthday_gift_wish": "神燈許願",
    "birthday_gift_cake": "金色蛋糕",
    "birthday_gift_lion": "獅王祝福",
    "birthday_gift_biggift": "豪華禮物",
    "guild_page_fee": "每筆收取 $2 手續費",
    "guild_page_saudi": "沙烏地阿拉伯",
    "guild_page_morocco": "摩洛哥",
    "guild_page_bank": "銀行",
    "guild_page_name": "姓名（英文）",
    "guild_page_name_english": "姓名只能為英文",
    "guild_page_bank_number": "銀行帳號",
    "guild_page_enter": "請輸入正確的銀行帳號",
    "guild_page_address": "地址（英文）",
    "guild_page_address_english": "地址只能為英文",
    "guild_page_country": "國家/地區",
    "guild_page_holder_name": "帳戶姓名",
    "guild_page_sa": "例如 SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "格式：街道, 區域, 城市, 省, 國家",
    "guild_page_minimum": "3. 最低提現金額為 {n} Coins",
    "withdraw_input_amount": "輸入金額",
    "withdraw_submit": "提現",
    "withdraw_quantity": "提現數量",
    "withdraw_actual_received": "實際到帳金額",
    "common_confirm": "確定",
    "common_cancel": "取消",
    "withdraw_error_min_amount": "未達最低提現金額",
    "withdraw_error_max_amount": "超出提現上限",
    "withdraw_error_max_p_coin": "超出可提現金幣",
    "guild_can_with_usd": "可提現(≈USD {n})",
    "guild_pending_settlement": "待結算",
    "guild_funds_operation": "資金操作",
    "guild_withdrawable_amount_title": "可提現金額",
    "guild_withdrawable_amount_tip1": "1. 為保障資金安全、降低安全風險，系統將對每一筆金幣收入進行風控審核，審核期間內金幣處於【待結算】狀態。",
    "guild_withdrawable_amount_tip2": "2. 審核最晚在{s}小時內完成。若審核通過，金幣將從【待結算】移至【可提現】；未通過時，系統將依規則處理。",
    "guild_withdrawable_amount_tip3": "3. 如因提現失敗退回等特殊情況，可立即提取。",
    "guild_got_it": "知道了",
    "guild_pending_settlement_detail": "待結算明細",
    "guild_pending_settlement_tip": "金幣收入需完成安全結算後變成「可提現金額」，預計最晚在{s}小時後進入可提現餘額。",
    "guild_pending_settlement_amount": "待結算金額",
    "guild_pending_settlement_last_30_days": "僅展示過去{n}小時的記錄",
    "guild_pending_settlement_list_tips": "僅展示{n}小時內的待結算收入。若待結算金額已被使用或扣減，將不會在此顯示，可前往",
    "guild_pending_settlement_list_tips_btn": "金幣記錄頁",
    "guild_pending_settlement_list_tips_look": "查看",
    "guild_pending_stamp_settled": "已結算",
    "guild_pending_stamp_used": "已使用",
    "guild_pending_stamp_deducted": "已扣減",
    "guild_record_guild_reward": "公會獎勵",
    "guild_record_gift": "收禮",
    "guild_order_id": "訂單ID",
    "guild_withdraw_record_total": "共{s}筆",
    "guild_status_reseller_review": "待reseller審核",
    "guild_status_security_review": "安全復查中",
    "guild_select_withdraw_amount": "選擇提現金額",
    "guild_reference_fee": "手續費",
    "guild_change_channel": "更換",
    "guild_change_channel_title": "更換渠道",
    "guild_current_can_withdraw": "目前可提現",
    "guild_confirm_bind": "確認綁定",
    "guild_bind_notice_title": "提示",
    "guild_bind_tip_1": "姓名需與帳戶實名一致",
    "guild_bind_tip_2": "帳戶資訊錯誤會導致提現失敗，無法入帳，請仔細確認每一個資訊再提交",
    "guild_confirm_withdraw_info": "確認提現資訊",
    "guild_withdraw_amount_label": "提現金額",
    "guild_estimated_arrival_time": "預計到帳時間",
    "guild_confirm_info_tip": "請仔細確認提現資訊，若資訊有誤，該筆訂單將無法入帳",
    "guild_modify": "修改",
    "guild_confirm_submit": "確認提交",
    "guild_withdraw_success_tip": "預計{s}個工作日內到帳，請耐心等待。你可前往【提現頁】-右上角【提現記錄】查看進度。",
    "guild_name": "姓名",
    "guild_bank_account": "銀行帳號",
    "guild_please_enter": "請輸入",
    "guild_withdraw_submit_success": "提交成功",
    "guild_withdraw_success_tip2": "預計{s}個工作日內到帳，請耐心等待。你可前往【提現頁】-右上角【提現記錄】查看進度。",
    "guild_platform_settlement_success_tip": "付款將會在下週一統一處理，請耐心等待。你可前往【提現頁】-右上角【提現記錄】查看進度。",
    "guild_transfer_to_reseller": "轉移給分銷商",
    "guild_transfer_to_reseller_label": "轉移給RESELLER",
    "guild_reseller_confirm_desc": "請確認已與RESELLER溝通好付款事宜。當你點擊「確認」後，你將扣除",
    "guild_reseller_confirm_tip_1": "1.請提前與Reseller溝通好線下打款事宜；",
    "guild_reseller_confirm_tip_2": "2.若對方拒絕，你的金幣將自動退回；",
    "guild_reseller_confirm_tip_3": "3.最低提現數為{n}金幣。",
    "guild_leader_settle_subtitle": "由公會長線下與你結算",
    "guild_leader_confirm_desc": "請確認已與公會長溝通好打款事宜。當你點擊「確認」後，你將扣除",
    "guild_leader_confirm_tip_1": "1. 此操作將向公會長發起申請，由公會長線下向你打款；",
    "guild_leader_confirm_tip_2": "2.請提前與會長確認好收款方式（銀行卡/USDT等）；若公會長拒絕，你的coins將自動退回；",
    "guild_leader_confirm_tip_3": "3.最低提現數為{n}金幣；",
    "guild_leader_confirm_tip_4": "4.若公會長確認已打款但你未收到款項，請保留聊天記錄並向平台申訴",
    "guild_leader_confirm_tip_4_prefix": "5.若公會長確認已經付款但你未收到款項，請保留聊天記錄並向平台申訴",
    "guild_leader_platform_appeal": "向平台申訴",
    "pixNamePlaceholder": "輸入pix用戶名",
    "pixIdType": "ID類型",
    "transfer": {
        "bindSuccess": "綁定成功",
        "error": "操作失敗，請稍後再試"
    },
    "pixSelectIdTypePlaceholder": "選擇ID類型",
    "pixIdPlaceholder": "輸入你的{s}",
    "pixSelectAccountTypePlaceholder": "选择pix账户类型",
    "pixAccountPlaceholder": "輸入你的{s}",
    "whatsAppIdPlaceholder": "輸入你的whatsapp ID",
    "pixCpfLengthError": "CPF必須為11位數字",
    "pixCnpjLengthError": "CNPJ必須為14位數字",
    "pixCpfNotMatchError": "兩次填寫的CPF不一致",
    "pixCnpjNotMatchError": "兩次填寫的CNPJ不一致",
    "pixFormatError": "格式錯誤",
    "notFilled": "{s}未填寫",
    "formatErrorCheck": "格式錯誤，請檢查",
    "certi_tips": "提示",
    "certi_tips1": "為保護帳號安全、降低黑產攻擊風險，需完成認證才能繼續操作。請前往APP內【我的】-【認證中心】完成認證再繼續操作。",
    "certi_tips2": "去認證",
    "certi_tips3": "目前版本過低，請升級後再試",
    "certi_tips4": "為保護帳號安全、降低黑產攻擊風險，需完成認證才能繼續操作。",
    "ff": "火箭升空 挑戰高倍！",
    "dd": "立即起飛",
    "guild_country": "國家/地區",
    "guild_bank_name": "銀行",
    "guild_iban": "IBAN",
    "guild_whatsapp": "WhatsApp",
    "guild_document_type": "證件類型",
    "guild_document_id": "證件號",
    "guild_account_type": "帳戶類型",
    "guild_address": "地址",
    "guild_settlement_weekly_process": "每週一統一處理",
    "withdrawal_channel": "提現渠道",
    "guild_whatsapp_contact_tip": "請留下你的聯絡方式，我們將用WhatsApp與你聯繫",
    "guild_bind": "綁定",
    "guild_settlement_input_amount": "輸入提現金額",
    "gift_sphinx6": "金字塔",
    "gift_sphinx7": "Monas塔",
    "guild_no_more_data": "已無更多內容",
    "guild_bind_channel_toast": "請先綁定渠道資訊"
}
